import React from 'react'
import type { ComparisonContent, FaqEntry, FeatureCardContent, FooterContent, ProblemSolutionContent } from './nexusLandingContent'

export const ProblemSolutionSection: React.FC<{ content: ProblemSolutionContent }> = ({ content }) => (
  <section className="landing-section landing-section--muted" id="platform">
    <div className="container stack-lg">
      <div className="landing-section-heading">
        <p className="landing-eyebrow">{content.eyebrow}</p>
      </div>
      <div className="landing-about-grid">
        <article className="landing-info-card landing-info-card--large">
          <h2>{content.problemTitle}</h2>
          <p>{content.problemCopy}</p>
        </article>
        <article className="landing-info-card landing-info-card--large">
          <h2>{content.solutionTitle}</h2>
          <p>{content.solutionCopy}</p>
        </article>
      </div>
    </div>
  </section>
)

export const ComparisonListSection: React.FC<{ content: ComparisonContent }> = ({ content }) => (
  <section className="landing-section" id="workflow">
    <div className="container stack-lg">
      <div className="landing-section-heading">
        <p className="landing-eyebrow">{content.eyebrow}</p>
        <h2>{content.title}</h2>
      </div>
      <div className="landing-way-grid">
        <article className="landing-way-card landing-way-card--old">
          <h3>{content.oldWayTitle}</h3>
          <ul>
            {content.oldWay.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </article>
        <article className="landing-way-card landing-way-card--new">
          <h3>{content.newWayTitle}</h3>
          <ul>
            {content.newWay.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </article>
      </div>
    </div>
  </section>
)

export const FeatureGrid: React.FC<{ title: string; features: FeatureCardContent[] }> = ({ title, features }) => (
  <section className="landing-section landing-section--muted" id="network-os">
    <div className="container stack-lg">
      <div className="landing-section-heading">
        <h2>{title}</h2>
      </div>
      <div className="landing-card-grid landing-card-grid--two">
        {features.map((feature) => (
          <article className="panel landing-info-card" key={feature.title}>
            <h3>{feature.title}</h3>
            <p>{feature.copy}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export const UseCaseGrid: React.FC<{ title: string; useCases: FeatureCardContent[] }> = ({ title, useCases }) => (
  <section className="landing-section" id="use-cases">
    <div className="container stack-lg">
      <div className="landing-section-heading"><h2>{title}</h2></div>
      <div className="landing-card-grid">
        {useCases.map((useCase) => (
          <article className="panel landing-info-card" key={useCase.title}>
            <h3>{useCase.title}</h3>
            <p>{useCase.copy}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export const FaqSection: React.FC<{ eyebrow: string; title: string; items: FaqEntry[] }> = ({ eyebrow, title, items }) => (
  <section className="landing-section landing-section--muted" id="faq">
    <div className="container stack-lg">
      <div className="landing-section-heading">
        <p className="landing-eyebrow">{eyebrow}</p>
        <h2>{title}</h2>
      </div>
      <div className="landing-faq-list">
        {items.map((item) => (
          <details className="landing-faq-item" key={item.question}>
            <summary>{item.question}</summary>
            <p>{item.answer}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
)

export const LandingFooter: React.FC<{ content: FooterContent }> = ({ content }) => (
  <footer className="landing-footer">
    <div className="container landing-footer__inner">
      <p>{content.copyright}</p>
      <nav aria-label="NexusWorkforce360 footer links">
        {content.links.map((link) => <a key={link.href} href={link.href}>{link.label}</a>)}
      </nav>
    </div>
  </footer>
)
